<template>
    <div class="fill-height">
      <d-card-body class="card d-flex cPointer fill-height">
        <div class="ext-center fill-parent" style="padding-bottom:5px;">
          <span class="text-uppercase summary-header">{{title}}</span>
          <template v-if="!isLoading">
            <template v-if="!isZeroed">
              <div class="stats-small__data d-flex flex-column">
                <table class="table mb-0">
                  <tbody>
                    <template v-for="(item, index) in items" >
                      <tr :key="index" :style="item.style">
                        <td class="tb-row" v-if="item.icon != undefined" style="text-align:center">
                          <i :class="item.icon"></i>
                        </td>
                        <td class="tb-row" v-if="item.label != undefined">
                          {{item.label}}
                        </td>
                        <td class="tb-row" v-if="item.releaseQtd != undefined">
                          {{item.releaseQtd | number}} lançamento{{item.releaseQtd != 1 ? 's' : ''}}
                        </td>
                        <td class="tb-row" :style="styleAmount" v-if="item.amount != undefined">
                          {{item.amount | currency}}
                        </td>
                      </tr>
                    </template>
                    <template v-if="total">
                      <tr> 
                        <td class="tb-row-empty" v-if="total.icon != undefined"/>
                        <td class="tb-row-empty" v-if="total.label != undefined"/>
                        <td class="tb-row-empty" v-if="total.releaseQtd != undefined"/>
                        <td class="tb-row-empty" v-if="total.amount != undefined"/>
                      </tr>
                      <tr :style="total.style">
                        <td class="tb-row" v-if="total.icon != undefined" style="text-align:center">
                          <i :class="total.icon"></i>
                        </td>
                        <td class="tb-row" v-if="total.label != undefined">
                          {{total.label}}
                        </td>
                        <td class="tb-row" v-if="total.releaseQtd != undefined">
                          {{total.releaseQtd | number}} lançamento{{total.releaseQtd != 1 ? 's' : ''}}
                        </td>
                        <td class="tb-row" v-if="total.amount != undefined" :style="styleAmount">
                          {{total.amount | currency}}
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </template>
            <template v-else>
              <div class="no-value">
                {{messageEmpty}}
              </div>
            </template>
          </template>
          <template v-else>
            <div style="text-align: center; padding: 10px">
              <loader :small="true" :isLoading="isLoading"/>
            </div>
          </template>
        </div>
      </d-card-body>
    </div>
</template>


<script>
export default {
  name: "SummaryCard",
  props: {
    title:{
      type: String,
      required: true,
    },
    styleAmount:{
      type: String,
      default:() => ''
    },
    messageEmpty:{
      type: String,
      default:() => 'Não há lançamentos no periodo.'
    },
    items:{
      type: Array,
      required: false,
      //Exemplo
      //default: () => [ 
      //  {label: 'Exemplo 1', releaseQtd: 2, amount: 20.30, style: "color: green",  icon: 'fas fa-exchange-alt'},
      //  {label: 'Exemplo 2', releaseQtd: 1, amount: 2.30, style: "color: red",  icon: 'fas fa-exchange-alt'}
      //]
    },
    total:{
      type: Object,
      //Exemplo
      //default: () => ({label: 'Exemplo Total', releaseQtd: 2, amount: 18.00, style: "color: green",  icon: 'fas fa-exchange-alt'})
    },
    isLoading:{
      type: Boolean,
      default:() => true
    },
  },
  computed:{
    isZeroed(){
      return !Object.values(this.items).some(elem => elem.amount > 0 || elem.releaseQtd > 0);
    }
  }
};
</script>

<style lang="scss" scoped>
.summary-header {
  text-align: center;
  background: rgb(231, 231, 243);
  max-width: 100%;
  display: block;
  color: #000080;
  font-weight: bold;
}
.no-value {
  padding-top: 2px;
  text-align:center;
}
.fill-parent{
  width: 100%;
  width: -moz-available;          /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;  /* Mozilla-based browsers will ignore this. */
  width: fill-available;
}
/deep/ .card, /deep/ .card-small, /deep/ .card-body, /deep/ .card-small .card-body{
  padding: unset;
  box-shadow: 0 0.46875rem 1.1875rem rgba(90,97,105,0.1),0 0.9375rem 1.40625rem rgba(90,97,105,0.1),0 0.25rem 0.53125rem rgba(90,97,105,0.12),0 0.125rem 0.1875rem rgba(90,97,105,0.1);
}
.fill-height {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.tb-row{
  padding: .25rem;
  text-align: left;
  border: 0px;
  font-size: 12px;
}
.tb-row-empty{
  padding: .1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/sub-components/Generic/SummaryCard.vue